import carbongraph from "../images/clients/carbongraph.png";
import getgreen from "../images/clients/getgreen.png";
import harp from "../images/clients/harp.png";
import lg from "../images/clients/lg.png";
import lmnt from "../images/clients/lmnt.png";
import numistoken from "../images/clients/numistoken.png";
import ore from "../images/clients/ore.png";
import otterz from "../images/clients/otterz.png";
import relativity from "../images/clients/relativity.png";
import superhuman from "../images/clients/superhuman.png";
import walmart from "../images/clients/walmart.png";
import webai from "../images/clients/webai.png";
import woosh from "../images/clients/woosh.png";
import ibm from "../images/clients/ibm.png";
import bm from "../images/clients/bm.png";
import operative from "../images/clients/operative.png";
import matx from "../images/clients/matx.png";

export const clients = [
    relativity, 
    bm,
    ibm,
    lg,
    walmart,
    superhuman,
    webai,
    matx,
    carbongraph,
    getgreen,
    harp,
    lmnt,
    numistoken,
    ore,
    otterz,
    woosh,
    operative,
];